// Single source of truth for "is this a gym-settings screen?".
//
// Settings screens render in focus mode: no app sidebar, no profile menu, just the
// settings lane and an "Exit Settings" control. That matters beyond layout — anything
// that offers a way back into the rest of the app has to know it will be invisible
// here. AdminClientLayout and FloatingSetupGuide both need the same answer, and the
// list had already been copy-pasted once; a third copy would drift.

// Keep this in sync with the directories under
// src/app/(admin)/dashboard/admin/(settings)/ — every page in that route group renders
// the settings rail and must be listed here. The old inline copy of this list had
// drifted and was missing three of them; settingsFocusMode.test.ts now asserts the list
// against the filesystem so it can't drift again silently.
const SETTINGS_FOCUS_PREFIXES = [
  '/dashboard/admin/auto-checkin-settings',
  '/dashboard/admin/automated-notifications',
  '/dashboard/admin/billing-policies',
  '/dashboard/admin/birthday-shoutouts',
  '/dashboard/admin/brand-profile',
  '/dashboard/admin/brand-theme',
  '/dashboard/admin/email',
  '/dashboard/admin/evaluation-videos',
  // Gym Closings is a Settings page (plan 2026-05-21-004, U2).
  '/dashboard/admin/gym-closings',
  '/dashboard/admin/kiosk-tablets',
  '/dashboard/admin/locations',
  '/dashboard/admin/payout-settings',
  '/dashboard/admin/policies',
  '/dashboard/admin/requirements',
  // RSVP Settings lives in the settings route group and uses the same chrome.
  '/dashboard/admin/rsvp-settings',
  '/dashboard/admin/settings',
] as const;

export function isSettingsFocusPath(pathname: string | null | undefined): boolean {
  if (!pathname) return false;
  // The settings index itself.
  if (pathname === '/dashboard/admin') return true;
  // NOTE: no check for the literal '(settings)' segment — Next route groups never
  // appear in the URL, so the old inline version's check for it was dead code.
  //
  // Match the exact route or a child of it, NOT a bare startsWith: '/dashboard/admin/
  // email' would otherwise swallow '/dashboard/admin/email-testing', which lives
  // outside the (settings) group and must keep its app sidebar and setup guide.
  return SETTINGS_FOCUS_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}
